import React from 'react';
import './Button.css';

/**
 * Aurora-styled button. Renders an <a> when `href` is given, otherwise a <button>.
 *
 * @param {'primary' | 'ghost' | 'subtle'} variant
 */
export default function Button({ variant = 'primary', href, children, ...rest }) {
  const className = `btn btn--${variant}`;

  if (href) {
    return (
      <a href={href} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={className} {...rest}>
      {children}
    </button>
  );
}
